export const LANGUAGES = {
  aa: {
    name: 'Afar',
    nativeName: 'Afaraf',
    flagCode: 'dj',
  },
  ab: {
    name: 'Abkhaz',
    nativeName: 'аҧсуа бызшәа',
    flagCode: 'ge',
  },
  ae: {
    name: 'Avestan',
    nativeName: 'avesta',
    flagCode: 'ir',
  },
  af: {
    name: 'Afrikaans',
    nativeName: 'Afrikaans',
    flagCode: 'za',
  },
  ak: {
    name: 'Akan',
    nativeName: 'Akan',
    flagCode: 'gh',
  },
  am: {
    name: 'Amharic',
    nativeName: 'አማርኛ',
    flagCode: 'et',
  },
  an: {
    name: 'Aragonese',
    nativeName: 'aragonés',
    flagCode: 'es',
  },
  ar: {
    name: 'Arabic',
    nativeName: 'العربية',
    flagCode: 'sa',
  },
  as: {
    name: 'Assamese',
    nativeName: 'অসমীয়া',
    flagCode: 'in',
  },
  av: {
    name: 'Avaric',
    nativeName: 'авар мацӀ',
    flagCode: 'ru',
  },
  ay: {
    name: 'Aymara',
    nativeName: 'aymar aru',
    flagCode: 'bo',
  },
  az: {
    name: 'Azerbaijani',
    nativeName: 'azərbaycan dili',
    flagCode: 'az',
  },
  ba: {
    name: 'Bashkir',
    nativeName: 'башҡорт теле',
    flagCode: 'ru',
  },
  be: {
    name: 'Belarusian',
    nativeName: 'беларуская мова',
    flagCode: 'by',
  },
  bg: {
    name: 'Bulgarian',
    nativeName: 'български език',
    flagCode: 'bg',
  },
  bi: {
    name: 'Bislama',
    nativeName: 'Bislama',
    flagCode: 'vu',
  },
  bm: {
    name: 'Bambara',
    nativeName: 'bamanankan',
    flagCode: 'ml',
  },
  bn: {
    name: 'Bengali',
    nativeName: 'বাংলা',
    flagCode: 'bd',
  },
  bo: {
    name: 'Tibetan',
    nativeName: 'བོད་ཡིག',
    flagCode: 'cn',
  },
  br: {
    name: 'Breton',
    nativeName: 'brezhoneg',
    flagCode: 'fr',
  },
  bs: {
    name: 'Bosnian',
    nativeName: 'bosanski jezik',
    flagCode: 'ba',
  },
  ca: {
    name: 'Catalan',
    nativeName: 'Català',
    flagCode: 'ad',
  },
  ce: {
    name: 'Chechen',
    nativeName: 'нохчийн мотт',
    flagCode: 'ru',
  },
  ch: {
    name: 'Chamorro',
    nativeName: 'Chamoru',
    flagCode: 'gu',
  },
  co: {
    name: 'Corsican',
    nativeName: 'corsu',
    flagCode: 'fr',
  },
  cr: {
    name: 'Cree',
    nativeName: 'ᓀᐦᐃᔭᐍᐏᐣ',
    flagCode: 'ca',
  },
  cs: {
    name: 'Czech',
    nativeName: 'čeština',
    flagCode: 'cz',
  },
  cu: {
    name: 'Old Church Slavonic',
    nativeName: 'ѩзыкъ словѣньскъ',
    flagCode: 'bg',
  },
  cv: {
    name: 'Chuvash',
    nativeName: 'чӑваш чӗлхи',
    flagCode: 'ru',
  },
  cy: {
    name: 'Welsh',
    nativeName: 'Cymraeg',
    flagCode: 'gb-wls',
  },
  da: {
    name: 'Danish',
    nativeName: 'Dansk',
    flagCode: 'dk',
  },
  de: {
    name: 'German',
    nativeName: 'Deutsch',
    flagCode: 'de',
  },
  dv: {
    name: 'Divehi',
    nativeName: 'ދިވެހި',
    flagCode: 'mv',
  },
  dz: {
    name: 'Dzongkha',
    nativeName: 'རྫོང་ཁ',
    flagCode: 'bt',
  },
  ee: {
    name: 'Ewe',
    nativeName: 'Eʋegbe',
    flagCode: 'gh',
  },
  el: {
    name: 'Greek',
    nativeName: 'Ελληνικά',
    flagCode: 'gr',
  },
  en: {
    name: 'English',
    nativeName: 'English',
    flagCode: 'gb',
  },
  eo: {
    name: 'Esperanto',
    nativeName: 'Esperanto',
    flagCode: 'eu',
  },
  es: {
    name: 'Spanish',
    nativeName: 'Español',
    flagCode: 'es',
  },
  et: {
    name: 'Estonian',
    nativeName: 'eesti',
    flagCode: 'ee',
  },
  eu: {
    name: 'Basque',
    nativeName: 'euskara',
    flagCode: 'es',
  },
  fa: {
    name: 'Persian',
    nativeName: 'فارسی',
    flagCode: 'ir',
  },
  ff: {
    name: 'Fula',
    nativeName: 'Fulfulde',
    flagCode: 'ng',
  },
  fi: {
    name: 'Finnish',
    nativeName: 'suomi',
    flagCode: 'fi',
  },
  fj: {
    name: 'Fijian',
    nativeName: 'vosa Vakaviti',
    flagCode: 'fj',
  },
  fo: {
    name: 'Faroese',
    nativeName: 'Føroyskt',
    flagCode: 'fo',
  },
  fr: {
    name: 'French',
    nativeName: 'Français',
    flagCode: 'fr',
  },
  fy: {
    name: 'Western Frisian',
    nativeName: 'Frysk',
    flagCode: 'nl',
  },
  ga: {
    name: 'Irish',
    nativeName: 'Gaeilge',
    flagCode: 'ie',
  },
  gd: {
    name: 'Scottish Gaelic',
    nativeName: 'Gàidhlig',
    flagCode: 'gb-sct',
  },
  gl: {
    name: 'Galician',
    nativeName: 'galego',
    flagCode: 'es',
  },
  gn: {
    name: 'Guaraní',
    nativeName: "Avañe'ẽ",
    flagCode: 'py',
  },
  gu: {
    name: 'Gujarati',
    nativeName: 'ગુજરાતી',
    flagCode: 'in',
  },
  gv: {
    name: 'Manx',
    nativeName: 'Gaelg',
    flagCode: 'im',
  },
  ha: {
    name: 'Hausa',
    nativeName: 'هَوُسَ',
    flagCode: 'ng',
  },
  he: {
    name: 'Hebrew',
    nativeName: 'עברית',
    flagCode: 'il',
  },
  hi: {
    name: 'Hindi',
    nativeName: 'हिन्दी',
    flagCode: 'in',
  },
  ho: {
    name: 'Hiri Motu',
    nativeName: 'Hiri Motu',
    flagCode: 'pg',
  },
  hr: {
    name: 'Croatian',
    nativeName: 'Hrvatski',
    flagCode: 'hr',
  },
  ht: {
    name: 'Haitian',
    nativeName: 'Kreyòl ayisyen',
    flagCode: 'ht',
  },
  hu: {
    name: 'Hungarian',
    nativeName: 'magyar',
    flagCode: 'hu',
  },
  hy: {
    name: 'Armenian',
    nativeName: 'Հայերեն',
    flagCode: 'am',
  },
  hz: {
    name: 'Herero',
    nativeName: 'Otjiherero',
    flagCode: 'na',
  },
  ia: {
    name: 'Interlingua',
    nativeName: 'Interlingua',
    flagCode: 'eu',
  },
  id: {
    name: 'Indonesian',
    nativeName: 'Bahasa Indonesia',
    flagCode: 'id',
  },
  ie: {
    name: 'Interlingue',
    nativeName: 'Interlingue',
    flagCode: 'eu',
  },
  ig: {
    name: 'Igbo',
    nativeName: 'Asụsụ Igbo',
    flagCode: 'ng',
  },
  ii: {
    name: 'Nuosu',
    nativeName: 'ꆈꌠ꒿ Nuosuhxop',
    flagCode: 'cn',
  },
  ik: {
    name: 'Inupiaq',
    nativeName: 'Iñupiaq',
    flagCode: 'us',
  },
  io: {
    name: 'Ido',
    nativeName: 'Ido',
    flagCode: 'eu',
  },
  is: {
    name: 'Icelandic',
    nativeName: 'Íslenska',
    flagCode: 'is',
  },
  it: {
    name: 'Italian',
    nativeName: 'Italiano',
    flagCode: 'it',
  },
  iu: {
    name: 'Inuktitut',
    nativeName: 'ᐃᓄᒃᑎᑐᑦ',
    flagCode: 'ca',
  },
  ja: {
    name: 'Japanese',
    nativeName: '日本語',
    flagCode: 'jp',
  },
  jv: {
    name: 'Javanese',
    nativeName: 'basa Jawa',
    flagCode: 'id',
  },
  ka: {
    name: 'Georgian',
    nativeName: 'ქართული',
    flagCode: 'ge',
  },
  kg: {
    name: 'Kongo',
    nativeName: 'Kikongo',
    flagCode: 'cg',
  },
  ki: {
    name: 'Kikuyu',
    nativeName: 'Gĩkũyũ',
    flagCode: 'ke',
  },
  kj: {
    name: 'Kwanyama',
    nativeName: 'Kuanyama',
    flagCode: 'na',
  },
  kk: {
    name: 'Kazakh',
    nativeName: 'қазақ тілі',
    flagCode: 'kz',
  },
  kl: {
    name: 'Kalaallisut',
    nativeName: 'kalaallisut',
    flagCode: 'gl',
  },
  km: {
    name: 'Khmer',
    nativeName: 'ខេមរភាសា',
    flagCode: 'kh',
  },
  kn: {
    name: 'Kannada',
    nativeName: 'ಕನ್ನಡ',
    flagCode: 'in',
  },
  ko: {
    name: 'Korean',
    nativeName: '한국어',
    flagCode: 'kr',
  },
  kr: {
    name: 'Kanuri',
    nativeName: 'Kanuri',
    flagCode: 'ng',
  },
  ks: {
    name: 'Kashmiri',
    nativeName: 'कश्मीरी',
    flagCode: 'in',
  },
  ku: {
    name: 'Kurdish',
    nativeName: 'Kurdî',
    flagCode: 'iq',
  },
  kv: {
    name: 'Komi',
    nativeName: 'коми кыв',
    flagCode: 'ru',
  },
  kw: {
    name: 'Cornish',
    nativeName: 'Kernewek',
    flagCode: 'gb-eng',
  },
  ky: {
    name: 'Kyrgyz',
    nativeName: 'Кыргызча',
    flagCode: 'kg',
  },
  la: {
    name: 'Latin',
    nativeName: 'latine',
    flagCode: 'va',
  },
  lb: {
    name: 'Luxembourgish',
    nativeName: 'Lëtzebuergesch',
    flagCode: 'lu',
  },
  lg: {
    name: 'Ganda',
    nativeName: 'Luganda',
    flagCode: 'ug',
  },
  li: {
    name: 'Limburgish',
    nativeName: 'Limburgs',
    flagCode: 'nl',
  },
  ln: {
    name: 'Lingala',
    nativeName: 'Lingála',
    flagCode: 'cd',
  },
  lo: {
    name: 'Lao',
    nativeName: 'ພາສາລາວ',
    flagCode: 'la',
  },
  lt: {
    name: 'Lithuanian',
    nativeName: 'lietuvių kalba',
    flagCode: 'lt',
  },
  lu: {
    name: 'Luba-Katanga',
    nativeName: 'Kiluba',
    flagCode: 'cd',
  },
  lv: {
    name: 'Latvian',
    nativeName: 'latviešu valoda',
    flagCode: 'lv',
  },
  mg: {
    name: 'Malagasy',
    nativeName: 'fiteny malagasy',
    flagCode: 'mg',
  },
  mh: {
    name: 'Marshallese',
    nativeName: 'Kajin M̧ajeļ',
    flagCode: 'mh',
  },
  mi: {
    name: 'Māori',
    nativeName: 'te reo Māori',
    flagCode: 'nz',
  },
  mk: {
    name: 'Macedonian',
    nativeName: 'македонски јазик',
    flagCode: 'mk',
  },
  ml: {
    name: 'Malayalam',
    nativeName: 'മലയാളം',
    flagCode: 'in',
  },
  mn: {
    name: 'Mongolian',
    nativeName: 'Монгол хэл',
    flagCode: 'mn',
  },
  mr: {
    name: 'Marathi',
    nativeName: 'मराठी',
    flagCode: 'in',
  },
  ms: {
    name: 'Malay',
    nativeName: 'Bahasa Melayu',
    flagCode: 'my',
  },
  mt: {
    name: 'Maltese',
    nativeName: 'Malti',
    flagCode: 'mt',
  },
  my: {
    name: 'Burmese',
    nativeName: 'ဗမာစာ',
    flagCode: 'mm',
  },
  na: {
    name: 'Nauru',
    nativeName: 'Dorerin Naoero',
    flagCode: 'nr',
  },
  nb: {
    name: 'Norwegian Bokmål',
    nativeName: 'Norsk bokmål',
    flagCode: 'no',
  },
  nd: {
    name: 'Northern Ndebele',
    nativeName: 'isiNdebele',
    flagCode: 'zw',
  },
  ne: {
    name: 'Nepali',
    nativeName: 'नेपाली',
    flagCode: 'np',
  },
  ng: {
    name: 'Ndonga',
    nativeName: 'Owambo',
    flagCode: 'na',
  },
  nl: {
    name: 'Dutch',
    nativeName: 'Nederlands',
    flagCode: 'nl',
  },
  nn: {
    name: 'Norwegian Nynorsk',
    nativeName: 'Norsk nynorsk',
    flagCode: 'no',
  },
  no: {
    name: 'Norwegian',
    nativeName: 'Norsk',
    flagCode: 'no',
  },
  nr: {
    name: 'Southern Ndebele',
    nativeName: 'isiNdebele',
    flagCode: 'za',
  },
  nv: {
    name: 'Navajo',
    nativeName: 'Diné bizaad',
    flagCode: 'us',
  },
  ny: {
    name: 'Chichewa',
    nativeName: 'chiCheŵa',
    flagCode: 'mw',
  },
  oc: {
    name: 'Occitan',
    nativeName: 'occitan',
    flagCode: 'fr',
  },
  oj: {
    name: 'Ojibwe',
    nativeName: 'ᐊᓂᔑᓈᐯᒧᐎᓐ',
    flagCode: 'ca',
  },
  om: {
    name: 'Oromo',
    nativeName: 'Afaan Oromoo',
    flagCode: 'et',
  },
  or: {
    name: 'Oriya',
    nativeName: 'ଓଡ଼ିଆ',
    flagCode: 'in',
  },
  os: {
    name: 'Ossetian',
    nativeName: 'ирон æвзаг',
    flagCode: 'ge',
  },
  pa: {
    name: 'Panjabi',
    nativeName: 'ਪੰਜਾਬੀ',
    flagCode: 'in',
  },
  pi: {
    name: 'Pāli',
    nativeName: 'पाऴि',
    flagCode: 'in',
  },
  pl: {
    name: 'Polish',
    nativeName: 'Polski',
    flagCode: 'pl',
  },
  ps: {
    name: 'Pashto',
    nativeName: 'پښتو',
    flagCode: 'af',
  },
  pt: {
    name: 'Portuguese',
    nativeName: 'Português',
    flagCode: 'pt',
  },
  qu: {
    name: 'Quechua',
    nativeName: 'Runa Simi',
    flagCode: 'pe',
  },
  rm: {
    name: 'Romansh',
    nativeName: 'rumantsch grischun',
    flagCode: 'ch',
  },
  rn: {
    name: 'Kirundi',
    nativeName: 'Ikirundi',
    flagCode: 'bi',
  },
  ro: {
    name: 'Romanian',
    nativeName: 'Română',
    flagCode: 'ro',
  },
  ru: {
    name: 'Russian',
    nativeName: 'Русский',
    flagCode: 'ru',
  },
  rw: {
    name: 'Kinyarwanda',
    nativeName: 'Ikinyarwanda',
    flagCode: 'rw',
  },
  sa: {
    name: 'Sanskrit',
    nativeName: 'संस्कृतम्',
    flagCode: 'in',
  },
  sc: {
    name: 'Sardinian',
    nativeName: 'sardu',
    flagCode: 'it',
  },
  sd: {
    name: 'Sindhi',
    nativeName: 'सिन्धी',
    flagCode: 'pk',
  },
  se: {
    name: 'Northern Sami',
    nativeName: 'Davvisámegiella',
    flagCode: 'no',
  },
  sg: {
    name: 'Sango',
    nativeName: 'yângâ tî sängö',
    flagCode: 'cf',
  },
  si: {
    name: 'Sinhala',
    nativeName: 'සිංහල',
    flagCode: 'lk',
  },
  sk: {
    name: 'Slovak',
    nativeName: 'slovenčina',
    flagCode: 'sk',
  },
  sl: {
    name: 'Slovenian',
    nativeName: 'slovenščina',
    flagCode: 'si',
  },
  sm: {
    name: 'Samoan',
    nativeName: "gagana fa'a Samoa",
    flagCode: 'ws',
  },
  sn: {
    name: 'Shona',
    nativeName: 'chiShona',
    flagCode: 'zw',
  },
  so: {
    name: 'Somali',
    nativeName: 'Soomaaliga',
    flagCode: 'so',
  },
  sq: {
    name: 'Albanian',
    nativeName: 'Shqip',
    flagCode: 'al',
  },
  sr: {
    name: 'Serbian',
    nativeName: 'српски језик',
    flagCode: 'rs',
  },
  ss: {
    name: 'Swati',
    nativeName: 'SiSwati',
    flagCode: 'sz',
  },
  st: {
    name: 'Southern Sotho',
    nativeName: 'Sesotho',
    flagCode: 'ls',
  },
  su: {
    name: 'Sundanese',
    nativeName: 'Basa Sunda',
    flagCode: 'id',
  },
  sv: {
    name: 'Swedish',
    nativeName: 'Svenska',
    flagCode: 'se',
  },
  sw: {
    name: 'Swahili',
    nativeName: 'Kiswahili',
    flagCode: 'tz',
  },
  ta: {
    name: 'Tamil',
    nativeName: 'தமிழ்',
    flagCode: 'lk',
  },
  te: {
    name: 'Telugu',
    nativeName: 'తెలుగు',
    flagCode: 'in',
  },
  tg: {
    name: 'Tajik',
    nativeName: 'тоҷикӣ',
    flagCode: 'tj',
  },
  th: {
    name: 'Thai',
    nativeName: 'ไทย',
    flagCode: 'th',
  },
  ti: {
    name: 'Tigrinya',
    nativeName: 'ትግርኛ',
    flagCode: 'er',
  },
  tk: {
    name: 'Turkmen',
    nativeName: 'Türkmençe',
    flagCode: 'tm',
  },
  tl: {
    name: 'Tagalog',
    nativeName: 'Wikang Tagalog',
    flagCode: 'ph',
  },
  tn: {
    name: 'Tswana',
    nativeName: 'Setswana',
    flagCode: 'bw',
  },
  to: {
    name: 'Tonga',
    nativeName: 'faka Tonga',
    flagCode: 'to',
  },
  tr: {
    name: 'Turkish',
    nativeName: 'Türkçe',
    flagCode: 'tr',
  },
  ts: {
    name: 'Tsonga',
    nativeName: 'Xitsonga',
    flagCode: 'za',
  },
  tt: {
    name: 'Tatar',
    nativeName: 'татар теле',
    flagCode: 'ru',
  },
  tw: {
    name: 'Twi',
    nativeName: 'Twi',
    flagCode: 'gh',
  },
  ty: {
    name: 'Tahitian',
    nativeName: 'Reo Tahiti',
    flagCode: 'pf',
  },
  ug: {
    name: 'Uyghur',
    nativeName: 'ئۇيغۇرچە‎',
    flagCode: 'cn',
  },
  uk: {
    name: 'Ukrainian',
    nativeName: 'Українська',
    flagCode: 'ua',
  },
  ur: {
    name: 'Urdu',
    nativeName: 'اردو',
    flagCode: 'pk',
  },
  uz: {
    name: 'Uzbek',
    nativeName: 'Ўзбек',
    flagCode: 'uz',
  },
  ve: {
    name: 'Venda',
    nativeName: 'Tshivenḓa',
    flagCode: 'za',
  },
  vi: {
    name: 'Vietnamese',
    nativeName: 'Tiếng Việt',
    flagCode: 'vn',
  },
  vo: {
    name: 'Volapük',
    nativeName: 'Volapük',
    flagCode: 'eu',
  },
  wa: {
    name: 'Walloon',
    nativeName: 'walon',
    flagCode: 'be',
  },
  wo: {
    name: 'Wolof',
    nativeName: 'Wollof',
    flagCode: 'sn',
  },
  xh: {
    name: 'Xhosa',
    nativeName: 'isiXhosa',
    flagCode: 'za',
  },
  yi: {
    name: 'Yiddish',
    nativeName: 'ייִדיש',
    flagCode: 'il',
  },
  yo: {
    name: 'Yoruba',
    nativeName: 'Yorùbá',
    flagCode: 'ng',
  },
  za: {
    name: 'Zhuang',
    nativeName: 'Saɯ cueŋƅ',
    flagCode: 'cn',
  },
  zh: {
    name: 'Chinese',
    nativeName: '中文',
    flagCode: 'cn',
  },
  zu: {
    name: 'Zulu',
    nativeName: 'isiZulu',
    flagCode: 'za',
  },
};

export type LanguageCode = keyof typeof LANGUAGES;

export const LANGUAGES_LIST = Object.entries(LANGUAGES).map(([key, value]) => ({
  ...value,
  code: key,
}));
